import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { handleFieldError } from 'libs/api/errorHandle';
import { updateNickname } from 'libs/api/user';
import { showNotification } from 'libs/utils';
import { TModalProps } from 'modules/types';
import { TUpdateNickname, TUser, setUserInfo } from 'modules/user';
import { Form, Input, Modal, Button } from 'antd';
import { FormWrapper } from 'GlobalStyles';

function NicknameChangeModal({ modalState, setModalState }: TModalProps) {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const dispatch = useDispatch();

  function handleCancel() {
    form.resetFields();
    setModalState({ visible: false, record: '' });
  }

  function onClickSubmit() {
    form.validateFields().then((value) => {
      handleSubmit(value as TUpdateNickname);
    });

    async function handleSubmit(value: TUpdateNickname) {
      try {
        setSubmitButtonDisabled(true);
        const response = await updateNickname({
          nickname: form.getFieldValue('nickname'),
        } as TUpdateNickname);
        dispatch(setUserInfo(get(response, 'data') as TUser));
        modalState.onFinish && modalState.onFinish(get(response, 'data.nickname'));
        showNotification('success', '닉네임이 수정되었습니다');
        handleCancel();
      } catch (e) {
        handleFieldError(e, form);
        throw e;
      } finally {
        setSubmitButtonDisabled(false);
      }
    }
  }

  useEffect(() => {
    setVisible(modalState.visible);
  }, [modalState.visible]);

  return (
    <Modal
      title='닉네임 변경'
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={null}
      onCancel={handleCancel}
    >
      <FormWrapper style={{ padding: '0px' }}>
        <Form
          form={form}
          colon={false}
          className='form-inline'
          layout='vertical'
          initialValues={{ nickname: get(modalState, 'record.nickname') }}
        >
          <Form.Item name={'nickname'} label='닉네임' className='form-item'>
            <Input size='large' autoFocus={true} />
          </Form.Item>
          <div style={{ height: '40px' }}>
            <Button
              type='primary'
              htmlType='submit'
              size='large'
              onClick={onClickSubmit}
              loading={submitButtonDisabled}
              style={{ float: 'right' }}
            >
              수정
            </Button>
          </div>
        </Form>
      </FormWrapper>
    </Modal>
  );
}

NicknameChangeModal.defaultProps = {};

export default NicknameChangeModal;
